<div class="wrapper">
	<div class="go-back">
		<ion-icon (click)="dismiss()" src="../../../assets/topgolf/cross.svg"></ion-icon>
	</div>
	<div class="content">
		<ion-img src="../../../assets/promo.svg"></ion-img>
		@if (isAdded) {
			<h3>{{ 'add_promo_dialog.success_title' | translate }}</h3>
			<p>
				{{ 'add_promo_dialog.success_desc' | translate }}
			</p>
			<ion-button (click)="dismiss()">
				{{ 'add_promo_dialog.next' | translate }}
			</ion-button>
		}
		@if (!isAdded) {
			<h3>{{ 'add_promo_dialog.title' | translate }}</h3>
			<div class="input-block">
				<ion-input [class.error]="inputControl.hasError('notExist')" [formControl]="inputControl" type="text"></ion-input>
				@if (inputControl.hasError('notExist')) {
					<div class="error-message">
						<span> {{ errorMessage ? errorMessage : ('add_promo_dialog.error' | translate) }} </span>
					</div>
				}
			</div>
			<ion-button (click)="addPromo()" [disabled]="inputControl.invalid">
				@if (!isLoading) {
					{{ 'add_promo_dialog.select' | translate }}
				} @else {
					<ion-spinner></ion-spinner>
				}
			</ion-button>
		}
	</div>
</div>
